

<template>
  <!-- Footer -->
  <footer class="py-3 bg-theme">
    <div class="container text-gray">
      <p class="m-0 text-center text-gray">
        <router-link to="/terms" class="text-point">이용약관</router-link> &nbsp;
        <router-link to="/notice" class="text-point"> 공지사항</router-link> &nbsp;
        <!-- <router-link to="/qna" class="text-point"> Q&A</router-link> &nbsp;
        <router-link to="/archive" class="text-point"> 자료집</router-link> &nbsp; -->
        <router-link :to="{name : 'adminIndex'}" class="text-point" v-if="$auth.check() && $auth.user().roleNames.includes('ADMIN')">관리자</router-link> &nbsp;
        <router-link to="/Questions" class="text-point">문의하기</router-link>
      </p>
      <p class="m-0 text-center text-copy">Copyright &copy; KARA DOING {{ currentYear }}</p>
    </div>
    <!-- /.container -->
  </footer>
</template>

<script>
//import MyLevel from '@/components/MyLevel.vue'

export default {
  name: 'Footer',
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>
<style>
</style>
